import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

declare var $:any;
@Component({
  selector: 'app-sura-select',
  templateUrl: './sura-select.component.html',
  styleUrls: ['./sura-select.component.css'],
})
export class SuraSelectComponent implements OnInit, OnChanges {

  selectedItem: any;

  @Input()
  items: any[];

  @Input()
  default: string;

  @Input()
  id: string;

  @Output()
  selected = new EventEmitter<string>();

  status: boolean;

  selectedText: string;
 constructor() {
    this.selectedItem = 0;
    this.status = false;
    this.selectedText = this.default;
  }

  ngOnInit(): void {

  }

  onClickChild(value: string, name: string, url: string): void {
    this.selected.emit(value);
    this.status = !this.status;
    this.selectedText = name;
    localStorage.setItem('urlAseguradora', url);
  }

  onClickedOutside(e: Event): void {
    this.status = false;
  }

  onClickParent(): void {
    this.status = !this.status;
  }

  ngOnChanges(changes: SimpleChanges): void {
    for (const propName in changes) {
      if (propName === 'items') {
        if (this.items.length > 0)
        {
          this.selectedItem = 0;
          this.selectedText = this.items[0].patente + ' - ' +
                              this.items[0].marca + ' ' +
                              this.items[0].modelo + ' - ' +
                              this.items[0].anno;
        }
      }
    }
  }

  onKeyDown(e: KeyboardEvent): void {
  }

  isHeighShort(): boolean {
    if (typeof this.items !== 'undefined') {
      return this.items.length < 6;
    }
    return false;
  }

}
